import { Content, DefaultPage } from '@shared/layout/DefaultPage'
import { BackArrowHeader } from '@widgets/BackArrowHeader'
import TisitIcon from '@assets/icons/tisit_logo.png'
import { Centered } from '@shared/layout/Centered'
import { Heading } from '@ui/Heading'
import ClubIcon from '@assets/icons/ClubIcon.png'
import { AdvantageItem } from './advantage'
import { ButtonMonth } from '@pages/Subscription/ui/button.month'
import { ButtonYear } from '@pages/Subscription/ui/button.year'
import { useState } from 'react'
import { YellowFilledButton } from '@shared/styles/YellowFilledButton'
import { useIonRouter } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'

const advantages: string[] = [
	'Персональные программы тренировок',
	'Безлимитный AI-чат',
	'Рекомендации по питанию и восстановлению',
	'Доступ в закрытый клуб Telegram',
	'Консультации с тренерами внутри Telegram чата',
	'Создавайте тренировки без ограничений',
	'Ранний доступ к новым функциям',
]

export const SubscriptionPage = () => {
	const [selected, setSelected] = useState<'month' | 'year'>('month')
	const nav = useIonRouter()

	return (
		<DefaultPage style={{ background: 'white' }}>
			<Content style={{ '--background': 'white' }}>
				<BackArrowHeader centeredChildren>
					<img src={TisitIcon} alt='' style={{ height: 56 }} />
				</BackArrowHeader>
				<Centered className={'flex-col'}>
					<Heading size={27} weight={700} className={'mt-6'}>
						Раскрой свой потенциал
					</Heading>
					<p className={'mt-5 text-[13px] font-light'}>
						Достижения начинаются с персонального подхода
					</p>
					<img src={ClubIcon} alt='' className={'w-[90px] mt-6'} />
				</Centered>
				<div className={'px-3 flex flex-col gap-y-4 mt-6'}>
					{advantages.map((advantage, index) => (
						<AdvantageItem advantageText={advantage} key={`advantage_${index}`} />
					))}
				</div>
				<div className={'flex justify-between mt-9'}>
					<ButtonMonth
						isSelected={selected === 'month'}
						onClick={() => {
							setSelected('month')
						}}
						className={'ml-1 w-[48%]'}
					/>
					<ButtonYear
						isSelected={selected === 'year'}
						onClick={() => {
							setSelected('year')
						}}
						className={'w-[48%] mr-1	'}
					/>
				</div>
				<YellowFilledButton
					style={{
						width: '100%',
						height: 50,
						fontSize: 16,
						fontWeight: 'bold',
						marginTop: 36,
						borderRadius: 12,
					}}>
					Оформить абонемент
				</YellowFilledButton>
				<div className={'flex mt-8 justify-between'}>
					<span
						className={'text-[11px] text-[#4D4F50]'}
						onClick={() => nav.push(ROUTES.overall.userAgreement)}>
						Условия использования
					</span>
					<span
						className={'text-[11px] text-[#4D4F50]'}
						onClick={() => {
							nav.push(ROUTES.overall.privacyPolicy)
						}}>
						Политика конфиденциальности
					</span>
				</div>
			</Content>
		</DefaultPage>
	)
}
